// extracted by mini-css-extract-plugin
module.exports = {"BoxLink":"BoxLink_BoxLink__IYF6i"};